import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetRadius } from '@/shared/actions/erp';
import { SaveRadiusComponent } from '../../shared/components/SaveRadiusComponent';
import { LoaderComponent } from '@/shared/components/ui';

export interface UpdateOltPageProps { }

const UpdateOltPage: React.FC<UpdateOltPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_olt);
  const returnUrlRadiusPage = ROUTER_PATHS.configuracionRED.radiusNav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetRadius(id!);

  if (isLoading || isRefetching) return null;

  if (!data?.data?.id_radius)
    return <Navigate to={returnUrlRadiusPage} />;

  if (isLoading) 
    return <LoaderComponent />

  return <SaveRadiusComponent title="Editar Radius" radius={data.data} />;
};

export default UpdateOltPage;
